<template>
    <section>
        <ais-breadcrumb
            class="breadcrumbs product-breadcrumbs-sidebar"
            :attributes="['categoryLvl0', 'categoryLvl1', 'categoryLvl2', 'categoryLvl3', 'categoryLvl4']"
        >
            <template #default="{ items, refine, createURL }">
                <ul class="crumbs">
                    <li>
                        <a :href="createURL()" @click.prevent="refine()">All Products</a>
                    </li>

                    <li v-for="item in items.slice(0, -1)" :key="item.label">
                        <a :href="createURL(item.value)" @click.prevent="refine(item.value)">
                            {{ item.label }}
                        </a>
                    </li>
                </ul>
            </template>
        </ais-breadcrumb>

        <product-subcategories />

        <div class="accordions">
            <div>
                <refinement-list
                    v-for="facet in facets"
                    :key="facet.name"
                    :attribute="facet"
                    :limit="50"
                    :sort-by="['name:asc']"
                    :stay-open="stayOpen"
                >
                    <template #item="{ item, refine, createURL }">
                        <span>
                            {{ item }}
                        </span>
                    </template>
                </refinement-list>
            </div>
        </div>
    </section>
</template>

<script>
import { SearchClient } from 'vue/AlgoliaSearch'
import RefinementList from 'vue/common/_refinement-list';
import Utility from 'Utility';

export default {
    data() {
        return {
            SearchClient,
        };
    },
    computed: {
        isProductsSection() {
            let sectionUrls = ['products', 'products/brands', 'services'];

            return sectionUrls.includes(this.baseUrl);
        },
        showProductCategories() {
            let hiddenUrls = ['products/brands', 'services'];
            if (hiddenUrls.includes(this.baseUrl)) {
                return false;
            }
            return true;
        },
    },
    methods: {
        listItemClasses(testUrl) {
            let testUrls = ['products', 'products/brands', 'services'];

            if (testUrls.includes(this.baseUrl)) {
                return (testUrl == this.baseUrl) ? ['ais-tree-menu__item', 'ais-tree-menu__item--active'] : 'ais-tree-menu__item';
            }

            return 'ais-tree-menu__item';
        },

        removeLastItem(items) {
            console.log('removeLastItem', items)
            return items.slice(0, -1)
        },

        filterTree(items, parent) {
            if (!items) {
                if (parent) {
                    return [ parent ]
                }
                return []
            }
            const refined = items.find(({ isRefined }) => isRefined)
            if (refined) {
                return this.filterTree(refined.data, refined)
            }

            if (parent) {
                return [ parent ]
            }
            return items
        },
        transformItems(items) {
            return this.filterTree(items)
        }
    },
    components: {
        'refinement-list': RefinementList
    },

    props: ['index', 'baseUrl', 'algolia', 'facets', 'stayOpen', 'query']
}
</script>
